export default "__VITE_ASSET__DcH_4lJr__"